var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scan_results modern-grid"},_vm._l((_vm.scanResults),function(sr,i){return _c('scan-result',{key:sr.received_at,staticClass:"extract-card",attrs:{"scan-result":sr,"previous":i === 0 ? null : _vm.scanResults[i-1]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }